import { useGetFarmerAnimals } from "@/features/Animals/animalApiSlice.ts";
import TableComponent from "@/features/Table/TableComponent.tsx";
import TopContent from "@/features/Table/TopContent.tsx";
import { statuses } from "@/utils/items.ts";
import {
  columns,
  INITIAL_VISIBLE_COLUMNS,
} from "@/features/Animals/AnimalColumns.ts";
import { SuspenseFallback } from "@/lib/Utils.Components.tsx";
import RenderCell from "@/features/Table/RenderCell.tsx";

const FarmerAnimals = () => {
  const { data, isLoading, isError, fetchStatus, refetch } = useGetFarmerAnimals();

  if (isError || fetchStatus === "paused") {
    return (
      <div role="alert">
        <p>Unable to load current animal records. Check your connection and retry.</p>
        <button type="button" onClick={() => void refetch()}>Retry</button>
      </div>
    );
  }

  if (isLoading) return <SuspenseFallback />;

  return (
    <TableComponent
      INITIAL_VISIBLE_COLUMNS={INITIAL_VISIBLE_COLUMNS}
      RenderCell={RenderCell}
      TopContent={TopContent}
      columns={columns}
      data={data}
      row={15}
      searchColumns={["gn", "name", "sex", "_id"]}
      setViewProfile={undefined}
      statuses={statuses}
    />
  );
};

export default FarmerAnimals;
